<div class="thank-you-container">
  <div class="thank-you-card">
    <div class="icon-container">
      <div class="checkmark-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="#4ADE80" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>

    <h2 class="thank-you-title">Thank You</h2>

    <p class="thank-you-message">
      <strong>Thank you for expressing your interest in the Super Top-Up Plan.</strong><br>
      Our team will get in touch with you shortly to assist you further with the details and benefits of the plan.
    </p>
  </div>
</div>